import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const create = (authToken: string, uri: string) => {
  const httpLink = createHttpLink({
    uri: uri,
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${authToken}`,
        httpOnly: true,
        secure: true,
        "Access-Control-Allow-Origin": "*",
        "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
        "X-Frame-Options": "SAMEORIGIN",
        "X-Content-Type-Options": "nosniff",
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  });
};

export function getApolloClient(token: string, endpoint: string) {
  return create(token, endpoint);
}
